/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getTransactionLogsData } from "../actions/transactionLogs.action";

const initialState: any = {};

const getTransactionLogsSlice = createSlice({
  name: "Get Transaction Logs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTransactionLogsData.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getTransactionLogsData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getTransactionLogsData.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default getTransactionLogsSlice.reducer;
